// Module
var code = `<a
  id="{{menuData.menuId}}"
  data-channel="ROUTE"
  data-item-id="{{itemId}}"
  data-page-id="{{menuData.pageId}}"
  data-stage="{{menuData.stage}}"
  data-container="{{menuData.container}}"
  data-section="{{menuData.section}}"
  data-topic="{{menuData.topic}}"
  data-subtopic="{{menuData.subtopic}}"
  data-event-prevent-default="true"
  class="menu-drawer-link menu-item-{{menuData.itemType}} item-{{menuData.pageId}}-{{menuData.stage}}-{{section}}-{{topic}}-{{subtopic}}  nav-level-{{level}}"
  href="{{menuData.url}}"
  >{{sidebarTitle}}{{text}}</a
>

<div class="sidebar-menu-container-box">
  {{#sidebarData}}

  <a
    id="{{menuData.menuId}}"
    data-channel="ROUTE"
    data-item-id="{{itemId}}"
    data-page-id="{{menuData.pageId}}"
    data-stage="{{menuData.stage}}"
    data-container="{{menuData.container}}"
    data-section="{{menuData.section}}"
    data-topic="{{menuData.topic}}"
    data-subtopic="{{menuData.subtopic}}"
    data-event-prevent-default="true"
    class="menu-drawer-link menu-item-{{menuData.itemType}} item-{{menuData.pageId}}-{{menuData.stage}}-{{section}}-{{topic}}-{{subtopic}}  nav-level-{{level}}"
    href="{{menuData.url}}"
    >{{sidebarTitle}}{{text}}</a
  >

  {{/sidebarData}}
</div>
`;
// Exports
module.exports = code;